import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Backdrop from "../Elements/Backdrop";
import BurgerIcon from "../../assets/svg/BurgerIcon";
import { FaInstagram, FaFacebookF, FaXTwitter, FaYoutube, FaTiktok } from "react-icons/fa6";
import { FiHome } from "react-icons/fi";

export default function TopNavbar() {
  const navegacion = useLocation();
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);
  const [dropdownCercaOpen, setDropdownCercaOpen] = useState(false);
  const dropdownCercaRef = useRef(null);
  const [dropdownInstitutionOpen, setDropdownInstitutionOpen] = useState(false);
  const dropdownInstitutionRef = useRef(null);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);

  // Manejar clic fuera para "Cerca de ti"
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownCercaRef.current && !dropdownCercaRef.current.contains(event.target)) {
        setDropdownCercaOpen(false);
      }
    };

    if (dropdownCercaOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownCercaOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownInstitutionRef.current && !dropdownInstitutionRef.current.contains(event.target)) {
        setDropdownInstitutionOpen(false);
      }
    };

    if (dropdownInstitutionOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownInstitutionOpen]);

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <NavbarWrapper className="animate whiteBg" style={y > 100 ? { height: "124px" } : { height: "140px" }}>
        <TopBar className="container flexSpaceCenter">
          <NavLinksIcons>
            <NavIcon to="https://instagram.com/gobgente">
              <FaInstagram />
            </NavIcon>
            <NavIcon to="https://facebook.com/gobgente">
              <FaFacebookF />
            </NavIcon>
            <NavIcon to="https://twitter.com/gobgente">
              <FaXTwitter />
            </NavIcon>
            <NavIcon to="https://youtube.com/gobgente">
              <FaYoutube />
            </NavIcon>
            <NavIcon to="https://www.tiktok.com/@gobgente">
              <FaTiktok />
            </NavIcon>
          </NavLinksIcons>
        </TopBar>
        <MainNavContainer className="container flexSpaceCenter whiteBg">
          <LogoLink className="pointer flexNullCenter" to="/">
            <img src={`${process.env.REACT_APP_CLOUDFRONT_IMAGES}/nuevos-logotipos/logo-coneecta-horzontal.png`} alt="Logo Coneecta" />
          </LogoLink>
          <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
          <NavBarStyled >
            <NavLinks>
              <NavItem to="https://coneecta.net/" active={navegacion.pathname === "/"}><FiHome /></NavItem>
              <NavItem to="https://coneecta.net/buscador-de-empleo" active={navegacion.pathname === "/buscador-de-empleo"}>Buscador de empleo</NavItem>
              <NavItem to="https://coneecta.net/empresa" active={navegacion.pathname === "/empresa"}>Empresa</NavItem>
              {/*
              <DropdownContainer onMouseEnter={() => setDropdownInstitutionOpen(true)}>
                <NavItem active={navegacion.pathname.includes("/instituciones/")}>Instituciones educativas</NavItem>
                {dropdownInstitutionOpen && (
                  <DropdownMenu ref={dropdownInstitutionRef}>
                    <DropdownLink to="/directivos/login">Directivos</DropdownLink>
                    <DropdownLink to="/vinculadores/login">Vinculadores</DropdownLink>
                  </DropdownMenu>
                )}
              </DropdownContainer>
              */}
              <DropdownContainer onMouseEnter={() => setDropdownCercaOpen(true)}>
                <NavItem active={navegacion.pathname.includes("/cerca-de-ti/")}>Cerca de ti</NavItem>
                {dropdownCercaOpen && (
                  <DropdownMenu ref={dropdownCercaRef}>
                    <DropdownLink to="https://coneecta.net/cerca-de-ti/empleo">Empleo</DropdownLink>
                    <DropdownLink to="https://coneecta.net/cerca-de-ti/educación">Educación</DropdownLink>
                    {/*<DropdownLink to="https://coneecta.net/cerca-de-ti/coneecta-en-números">Coneecta en números</DropdownLink>*/}
                  </DropdownMenu>
                )}
              </DropdownContainer>
              <NavItem to="https://centro-de-ayuda.coneecta.net/" active={navegacion.pathname.includes("/centro-de-ayuda/")}>Centro de ayuda</NavItem>
            </NavLinks>
          </NavBarStyled>
        </MainNavContainer>
      </NavbarWrapper>
    </>
  );
}

const NavbarWrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: white;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
  height: 40%;
  width: 100%;
`;

const MainNavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  height: 60%;
  background: white;
`;

const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-right: 50px;
  img {
    width: 14rem;
  }
`;

const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 860px) {
    display: block;
  }
`;

const NavBarStyled = styled.div`
  background: #004B87;
  padding: 20px;
  display: flex;
  padding-right: 50px;
  justify-content: right;
  border-top-left-radius: 300px;
  border-bottom-left-radius: 300px;
  width: 100%;
 height: 100%;

  @media (max-width: 860px) {
    display: none;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 50px;
`;

const NavLinksIcons = styled.div`
  display: flex;
  gap: 15px;
`;

const NavIcon = styled(Link)`
  font-size: 1.5rem;
  color: #004B87;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 15px;
  &:hover {
    color: #69B3E7;
  }
`;

const NavItem = styled(Link)`
  font-size: 16px;
  font-weight: 600;
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 15px;
  &:hover {
    color: #69B3E7;
  }
`;

const DropdownContainer = styled.div`
  position: relative;
  display: flex;  
  align-items: center;
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  margin-top: 20px;
  border-radius: 1.3rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  padding: 10px 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;


const DropdownLink = styled(Link)`
  display: block;
  padding: 12px 16px;
  text-decoration: none;
  color: #333;
  font-size: 14px;
  transition: background 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
  }
`;
